<!-- Welcome Component - Modern Bootstrap 5.3.7 -->
<div class="container-fluid py-4">
  <div class="row justify-content-center">
    <div class="col-12 col-lg-10 col-xl-8">
      
      <!-- Welcome Card -->
      <div class="card shadow-lg border-0 welcome-card">
        <div class="card-body p-4 p-md-5">
          
          <!-- Welcome Header -->
          <div class="text-center mb-4">
            <h1 class="display-6 fw-bold text-primary mb-3">
              {{ 'WELCOME.GREETING' | translate }} {{ getNameUser() }}
            </h1>
          </div>
          
          <!-- Main Content -->
          <div class="row align-items-center g-4">
            
            <!-- Image Column -->
            <div class="col-12 col-lg-5 text-center">
              <div class="welcome-image-container">
                <img 
                  src="assets/BillVeronicaWinston.png" 
                  alt="Bill, Veronica, and Winston - Course Instructors"
                  class="img-fluid rounded-3 shadow-sm welcome-image">
              </div>
            </div>
            
            <!-- Content Column -->
            <div class="col-12 col-lg-7">
              <div class="welcome-content">
                <p class="lead mb-4 text-muted">
                  {{ 'WELCOME.MESSAGE' | translate }}
                </p>
                
                <!-- Continue Button -->
                <div class="d-grid d-md-flex justify-content-md-start">
                  <button 
                    type="button"
                    (click)="continueToClasses()"
                    class="btn btn-primary btn-lg px-4 py-3 fw-semibold"
                    [attr.aria-label]="'WELCOME.CONTINUE_BUTTON' | translate">
                    <i class="fa fa-graduation-cap me-2"></i>
                    {{ 'WELCOME.CONTINUE_BUTTON' | translate }}
                  </button>
                </div>
              </div>
            </div>
            
          </div>
          
        </div>
      </div>
      
    </div>
  </div>
</div>
